import { Injectable } from '@angular/core';

import { ISimplePrice } from './ISimplePrice';
import { IBooking } from 'libraries/service/resources/model/search/IBooking';
import { IHotelBooking } from 'libraries/service/resources/model/search/hotel/IHotelBooking';
import { IHotelTraveller, HotelTravellerType } from 'libraries/service/resources/model/search/hotel/IHotelTraveller';
import { ITraveller } from 'libraries/service/resources/model/booking/ITraveller';
import { IBookingWithType } from './IBookingWithType';

@Injectable()
export class HotelBookingService {
    public isHotelBooking(booking: IBookingWithType): boolean {
        return booking && booking.type && booking.type.indexOf('stay') > -1;
    }

    public getPrice(booking: IHotelBooking): ISimplePrice {
        if (booking && booking.price) {
            const currency = Object.keys(booking.price.currency)[0];

            return {
                amount: booking.price.total.Cost[currency],
                currency,
            };
        }
    }

    public getMainTraveller(booking: IBooking): ITraveller {
        if (booking && booking.traveller) {
            return Object.keys(booking.traveller)
                .map((id: string) => booking.traveller[id])
                .filter((traveller: IHotelTraveller) => traveller.xType === HotelTravellerType.Adult)[0];
        }
    }
}